import { render, staticRenderFns } from "./DenunciaView.vue?vue&type=template&id=65196857&"
import script from "./DenunciaView.vue?vue&type=script&lang=ts&"
export * from "./DenunciaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports